<div class="file">
  @if (isImage() && fileCard().fileParams.id) {
    <app-file-card-image
      class="file-card-image"
      [fileId]="fileCard().fileParams.id"
      [imgSize]="imgSize()"
      [needBtn]="true"
      (openPreview)="handleClick('open')"
    />
  } @else {
    <button
      class="file-container"
      (click)="handleClick('open')"
    >
      <span class="file-name">
        {{ fileCard().fileParams.filename }}
      </span>
      <span class="file-size">
        {{ fileCard().fileParams.size | formatSize }}
      </span>
    </button>
  }
  <div
    class="action-btns"
    [class.no-edit]="!fileCard().isEditModeActive"
  >
    <div class="action-btns-row">
      <button
        mat-mini-fab
        tabindex="-1"
        class="action-btn"
        [class.full-width]="isNeedPreview()"
        (click)="handleClick('download')"
      >
        <mat-icon>download</mat-icon>
      </button>
      @if (!isNeedPreview()) {
        <button
          mat-mini-fab
          tabindex="-1"
          class="action-btn"
          (click)="handleClick('open')"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      }
    </div>

    @if (fileCard().isEditModeActive) {
      <div
        class="action-btns-row"
        @smoothShowHideHeight
      >
        <button
          mat-mini-fab
          tabindex="-1"
          class="action-btn"
          (click)="handleClick('delete')"
        >
          <mat-icon>delete</mat-icon>
        </button>
        <span
          tabindex="-1"
          class="action-btn action-btn-info"
          [matTooltip]="infoTooltip()"
          matTooltipClass="multiline-tooltip"
        >
          <mat-icon>info</mat-icon>
        </span>
      </div>
    }
  </div>
</div>
@if (isAction()) {
  <app-file-progress-bar-status/>
}
